import React from 'react'
import { Popconfirm, Popover } from 'antd'
import { Draggable } from 'react-beautiful-dnd'
import TaskList from '../Task/TaskList/TaskList'
import { IconSvg } from '../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import Title from '../../../componentIsoMophic/ScrumBoard/Title'
import CreateOrUpdateColumn from './ColumnCreateOrUpdate/ColumnCreateOrUpdate'
import { connect } from 'react-redux'
import scrumBoardActions from '../../../redux/scrumBoard/actions'
import drawerActions from '../../../redux/drawer/actions'

import MoreIcon from '../../assets/images/icon/16.svg'
import Plus from '../../assets/images/icon/24.svg'
import { Container, Header, PlusIcon, MoreActionsWrapper } from './Column.style'

const Column = ({
    title,
    column,
    tasks,
    index,
    boardId,
    editColumn,
    cancelEditColumn,
    deleteColumnWatcher,
    openDrawer,
    isScrollable,
}) => {
    const MoreActions = (
        <MoreActionsWrapper>
            <p onClick={() => editColumn(column)}>Rename Column</p>
            <p>
                <Popconfirm
                    title="Are you sure delete this Column?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() =>
                        deleteColumnWatcher({
                            column_id: column.id,
                            board_id: boardId,
                        })
                    }
                >
                    Delete Column
                </Popconfirm>
            </p>
        </MoreActionsWrapper>
    )
    console.log('column', column)
    return (
        <Draggable draggableId={title} index={index}>
            {(provided, snapshot) => (
                <Container
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    {column.editing ? (
                        <CreateOrUpdateColumn
                            initials={column}
                            onCancel={() => cancelEditColumn(column)}
                        />
                    ) : (
                        <Header isDragging={snapshot.isDragging}>
                            <Title
                                isDragging={snapshot.isDragging}
                                {...provided.dragHandleProps}
                            >
                                {title}
                            </Title>
                            {column.id === 'column2' && (
                                <PlusIcon
                                    src={Plus}
                                    color="black"
                                    onClick={() =>
                                        openDrawer({
                                            drawerType:
                                                column.id === 'column1'
                                                    ? 'CREATE_OR_EDIT_TASK'
                                                    : 'CREATE_OR_EDIT_REPORT',
                                            drawerProps: {
                                                columnId: column.id,
                                                idOfBoard: boardId,
                                            },
                                        })
                                    }
                                />
                            )}

                            {/* <Popover
                                placement="bottom"
                                content={MoreActions}
                                trigger="click"
                            >
                                <IconSvg
                                    src={MoreIcon}
                                    border="none"
                                    padding="0"
                                    mr={'0'}
                                />
                            </Popover> */}
                        </Header>
                    )}

                    <TaskList
                        listId={column.id}
                        listType="QUOTE"
                        column={column}
                        tasks={tasks}
                        internalScroll={isScrollable}
                    />
                </Container>
            )}
        </Draggable>
    )
}

export default connect(
    null,
    { ...scrumBoardActions, ...drawerActions }
)(Column)
